export const version = '231121-00000';



// WEBPACK FOOTER //
// ./src/version.js